import { DEFAULT_BLOTTER_SELECTION_READONLY_PARAMS, useAccordionFilterBuilder, type Position } from '@talos/kyoko';
import { usePositionsSubAccountsBlotterFoundation } from '../../../../Blotters/PositionsV3/SubAccounts/usePositionsSubAccountsBlotterFoundation';
import { usePositionsSubAccountsWsBlotter } from '../../../../Blotters/PositionsV3/SubAccounts/usePositionsSubAccountsWsBlotter';
import type { SubAccountPositionsTabProps } from '../../../../Blotters/PositionsV3/types';
import { MobileBlotterToolbar } from '../MobileBlotterToolbar';
import { MobilePositionsSettingsToggles } from './MobilePositionsSettingsToggles';
import { MobilePositionsBlotterView } from './sharedPositionsLogic';

interface MobilePositionsSubAccountsProps {
  blotterID: string;
  tab: SubAccountPositionsTabProps;
  onUpdateTab: (tab: SubAccountPositionsTabProps) => void;
}

/**
 * Mobile counterpart to desktop `PositionsSubAccountsBlotter`. The inner
 * component is keyed on `hierarchical` so the entire pipeline is remounted
 * when the variant changes — same pattern as desktop.
 */
export function MobilePositionsSubAccounts(props: MobilePositionsSubAccountsProps) {
  return <MobilePositionsSubAccountsInner key={`${!!props.tab.hierarchical}`} {...props} />;
}

function MobilePositionsSubAccountsInner({ blotterID, tab, onUpdateTab }: MobilePositionsSubAccountsProps) {
  const foundation = usePositionsSubAccountsBlotterFoundation({ blotterID, tab });
  const { blotterTable, groupingToggleButtons, hierarchical } = usePositionsSubAccountsWsBlotter({
    blotterID,
    tab,
    foundation,
    gridOptions: {
      rowSelection: DEFAULT_BLOTTER_SELECTION_READONLY_PARAMS,
    },
    wrapGroupingToggleButtons: true,
    useMobileLabels: true,
  });
  const filterBuilderAccordion = useAccordionFilterBuilder({
    filterBuilderProps: foundation.filterResults.filterBuilderProps,
  });

  return (
    <>
      <MobileBlotterToolbar
        {...filterBuilderAccordion}
        {...blotterTable.blotterTableFiltersProps}
        showDateRangePicker={false}
        accordionBodyPrefix={!hierarchical ? groupingToggleButtons : null}
        settingsContent={<MobilePositionsSettingsToggles tab={tab} onUpdateTab={onUpdateTab} />}
      />
      <MobilePositionsBlotterView<Position> blotterTable={blotterTable} />
    </>
  );
}
